/**
 @ngdoc service
 @name mapOfferTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    var mapOfferTileService = function(tileDataFactory) {

        var map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){
            var self = this;

            // Assigning tile factory function with parameters to variable
            var tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData);

            tileFactory.addFieldToColumn1(tileFactory.field.newField('jobTitle'))
            if(rawTileData.itemCorporateURI){
                tileFactory.addFieldToColumn1(tileFactory.field.newLinkBusinessModelField('itemUniversalId', 'itemPrincipleURI', 'itemCorporateURI'));
            }
            else {
                tileFactory.addFieldToColumn1(tileFactory.field.newLinkField('itemUniversalId','itemPrincipleURI'));
            }
            tileFactory.addFieldToColumn1(tileFactory.field.newField('payRates'))

            tileFactory.addFieldToColumn2(tileFactory.field.newField('candidateName'))
            tileFactory.addFieldToColumn2(tileFactory.field.newJoinField('candidateJobNoticePeriod', 'candidateJobNoticePeriodType', " "))
            tileFactory.addFieldToColumn2(tileFactory.field.newField('expectedStartDate', 'date'))

            tileFactory.addFieldToColumn3(tileFactory.field.newField('supplier'))
            tileFactory.addFieldToColumn3(tileFactory.field.newField('procurer'))
            tileFactory.addFieldToColumn3(tileFactory.field.newField('hiringManager'))

            tileFactory.addFieldToColumn4(tileFactory.field.newField('offerMadeDate', 'date'))

            if(rawTileData.acceptedDate) {
                tileFactory.addFieldToColumn4(tileFactory.field.newField('acceptedDate', 'date'))
            }
            if(rawTileData.rejectedDate) {
                tileFactory.addFieldToColumn4(tileFactory.field.newField('rejectedDate', 'date'))
            }

            tileFactory.addStatus(tileFactory.status.newStatus('statusString', 
                // Green
                ['Accepted'], 
                // Red
                ['Rejected', 'Withdrawn'],
                // Orange
                ['In Review', 'Offer Made']));

            if(rawTileData.rejectReason) {
                tileFactory.addFieldToColumn4(tileFactory.field.newField('rejectReason'))
            }

            return tileFactory.tileData;

        };

        return {
            map : map
        };
    };

    mapOfferTileService.$inject = ['tileDataFactory'];
    angular.module('app').factory('mapOfferTileService', mapOfferTileService);
}());